module.exports = __webpack_public_path__ + "img/05.5081f6f0.jpg";